import { FC } from "react";
import { TextField } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { Field } from "react-final-form";
import { BlogRubricFieldProps, FilmOptionType } from "./BlogRubricField.types";

const BlogRubricField: FC<BlogRubricFieldProps> = ({
  optionsItem,
  name = "data.tags",
}) => {
  const filter = createFilterOptions<FilmOptionType>();

  return (
    <Field subscription={{ value: true }} name={name}>
      {({ input }) => (
        <Autocomplete
          id="tags"
          multiple
          {...input}
          onChange={(event, newValue: any) => {
            if (typeof newValue === "string") {
              input.onChange({
                name: newValue,
              });
            } else if (newValue && newValue.inputValue) {
              input.onChange({
                name: newValue.inputValue,
              });
            } else {
              input.onChange(newValue);
            }
          }}
          filterOptions={(options, params) => {
            return filter(options, params);
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          options={optionsItem}
          getOptionLabel={(option) => {
            if (typeof option === "string") {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }
            return option.name;
          }}
          renderOption={(props, option) => <li {...props}>{option.name}</li>}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Blog tag" />}
        />
      )}
    </Field>
  );
};

export default BlogRubricField;
